import React from 'react';
import PropTypes from 'prop-types';

import { ListItemText as MUIListItemText } from '@mui/material';

export const ListItemText = props => <MUIListItemText {...props} />;

ListItemText.propTypes = {
  classes: PropTypes.object,
  disableTypography: PropTypes.bool,
  inset: PropTypes.bool,
  primary: PropTypes.node,
  primaryTypographyProps: PropTypes.object,
  secondary: PropTypes.node,
  secondaryTypographyProps: PropTypes.object
};

export default ListItemText;
